import StoryMixerTerm from "./StoryMixerTerm";

/**
 * Create a new instance of story mixer category object
 * @param  {object} StoryMixerCategory A js object from novelist select
 */
class StoryMixerCategory {
	constructor(storyMixerData) {
		this.name = storyMixerData.name;
		this.termList = generateTermList(storyMixerData.termList);
	}
}

function generateTermList(storyMixerTerms) {
	let termList = []
	if (storyMixerTerms) {
		termList = storyMixerTerms.map(data => {
			return new StoryMixerTerm(data);
		});
	}

	return termList;
}

export default StoryMixerCategory;
export {generateTermList};



// WEBPACK FOOTER //
// ./src/models/StoryMixerCategory.js